import { useFormik } from 'formik'
import owasp, { TestResult } from 'owasp-password-strength-test'
import React from 'react'
import * as Yup from 'yup'
import { ForgotPassword } from '@citruscamps/citrus-client'
import { LoadingButton } from '../../../../../components/LoadingButton/LoadingButton'
import translations from '../../../../../translations/en.json'

interface ResetPassword {
  password: string
  confirm_password: string
}

interface IProps {
  onSubmit: (values: ForgotPassword) => Promise<void>
}

export const RecoverPasswordForm = ({ onSubmit }: IProps) => {
  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldError,
    isSubmitting,
  } = useFormik<ResetPassword>({
    initialValues: {
      password: '',
      confirm_password: '',
    },
    validationSchema: Yup.object().shape({
      password: Yup.string()
        .required((translations as any)['error.password_required'])
        .test('password', '', function (val) {
          const passwordStrength: TestResult = owasp.test(val || '')
          return val &&
            !passwordStrength?.strong &&
            passwordStrength?.errors &&
            passwordStrength?.errors?.length > 0
            ? this.createError({
                message: passwordStrength.errors[0] || '',
                path: 'password',
              })
            : true
        }),
      confirm_password: Yup.string()
        .required((translations as any)['error.confirm_password_required'])
        .test('confirm', (translations as any)['error.confirm_password_match'], function (val) {
          return !val || !this.parent.password || val === this.parent.password
        }),
    }),
    onSubmit: async (value, { setSubmitting }) => {
      try {
        await onSubmit(value)
      } catch (e: any) {
        if (e.param) {
          setFieldError(e.param, e.message)
        } else if (e.message) {
          setFieldError('username', e.message)
        }
      }
      setSubmitting(false)
    },
  })
  return (
    <form onSubmit={handleSubmit}>
      <h4 className="mb-4">Please enter a new password</h4>
      <div className="mb-3">
        <label>Your new password</label>
        <input
          id="password"
          name="password"
          autoComplete="new-password"
          type="password"
          className={'form-control' + (touched.password && !!errors.password ? ' is-invalid' : '')}
          placeholder="Enter your new password"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          required
        />
        <div className="invalid-feedback d-block">
          {touched?.password && !!errors?.password ? errors?.password : '\u00A0'}
        </div>
      </div>
      <div className="mb-3">
        <label>Confirm your new password</label>
        <input
          id="confirm_password"
          name="confirm_password"
          autoComplete="new-password"
          type="password"
          className={
            'form-control' +
            (touched.confirm_password && !!errors.confirm_password ? ' is-invalid' : '')
          }
          placeholder="Enter your password again"
          value={values.confirm_password}
          onChange={handleChange}
          onBlur={handleBlur}
          required
        />
        <div className="invalid-feedback d-block">
          {touched?.confirm_password && !!errors?.confirm_password
            ? errors?.confirm_password
            : '\u00A0'}
        </div>
      </div>
      <div className="mb-3 mt-4">
        <LoadingButton type="submit" className="btn btn-primary btn-block" loading={isSubmitting}>
          Change Password
        </LoadingButton>
      </div>
    </form>
  )
}
